import styled from 'styled-components';

export const StyledList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
`;

export const StyledDateInfo = styled.p`
  margin-bottom: 0.25rem;
`;

export const StyledInfo = styled.div`
  display: flex;
  gap: 1rem;
`;
